export default [
  { path: '/base/menu', name: 'BaseMenu', component: () => import(/* webpackChunkName: "base-menu" */ './index.vue') }
]